import "./EcommerceRetail.module.css";
import Header from "@/reusable_sections/Header";
import IndustryHero from "./sections/IndustryHero";
import Ecommerce from "./sections/Ecommerce";
import Consultation from "./sections/Consultation";
import Footer from "@/reusable_sections/Footer";
export default function EcommerceRetailPage() {
  return <div>
      <Header />
      <IndustryHero />
      <Ecommerce />
      <Consultation />
      <Footer />
    </div>;
}